import _ from 'lodash';
import { createReducer } from '../../../../common/reduxHelpers';
import * as types from './actionTypes';
import { mergeIn, setIn, ref } from 'immutable-light';

export const initialState = {
    selected: [],
    isSaving: false,
    offers: [],
    skipShippingOrder: false,
    isOfferListLoading: false,
    isPriceListLoading: false,
    displayType: 'subscription'
};

const reducer = createReducer(initialState, {
    [types.SELECT_PRODUCT]: (state, action) => setIn(state, ['selected'], action.id),
    [types.ORDER_HARDWARE_SUCCESS]: (state, action) => mergeIn(state, [], {}),
    [types.SAVE_START]: (state, action) => setIn(state, ['isSaving'], true),
    [types.SAVE_STOP]: (state, action) => setIn(state, ['isSaving'], false),
    [types.FETCH_OFFERS_REQUEST]: (state) => setIn(state, ['isOfferListLoading'], true),
    [types.FETCH_OFFERS_SUCCESS]: (state, action) => mergeIn(state, [], {
        offers: action.response.offers.map(offer => ({...offer, price: {}})),
        isOfferListLoading: false
    }),
    [types.FETCH_OFFERS_FAILURE]: (state) => setIn(state, ['isOfferListLoading'], false),
    [types.FETCH_PRICES_REQUEST]: (state) => setIn(state, ['isPriceListLoading'], true),
    [types.FETCH_PRICES_SUCCESS]: (state, action) => {
        const prices = action.response;
        let offers = ref(state.offers);
        const mapped = offers.map(offer => ({
            ...offer, 
            price: prices.find(price => price.commercialProductId === offer.commercialProductId && price.offerId === offer.offerId) || {} 
        }));        
        return mergeIn(state, [], { offers: mapped, isPriceListLoading: false });
    },
    [types.FETCH_PRICES_FAILURE]: (state) => setIn(state, ['isPriceListLoading'], false),
    [types.SET_SKIP_SHIPPING_ORDER]: (state, action) => setIn(state, ['skipShippingOrder'], action.flag),
    [types.SET_DISPLAY_TYPE]: (state, action) => setIn(state, ['displayType'], action.displayType)

});

export default reducer;